import axios from 'axios'
import endpoints from '../../endpoints'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchBannerList() {
  try {
    const response = await axios.get(API_URL + endpoints.banner.list)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function createBanner(body) {
  try {
    const response = await axios.post(API_URL + endpoints.banner.create, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function updateBanner(body) {
  try {
    const response = await axios.post(API_URL + endpoints.banner.update, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function deleteBanner(bannerId) {
  try {
    const response = await axios.delete(API_URL + endpoints.banner.delete + bannerId)
    return response.data
  } catch (error) {
    throw error
  }
}
